<script lang="ts" setup>
import { ItemInterface } from '../../models/ItemModel'

const props = defineProps<{
  item: ItemInterface
  canCollect?: boolean
}>()

const emit = defineEmits(['itemClick'])
</script>

<template>
  <div
    class="item-item"
    :class="{
      done: props.item.quantity_collected == props.item.quantity_total,
    }"
  >
    <button v-if="props.canCollect" class="item-item__button" @click="emit('itemClick')">
      {{ props.item.title }}
    </button>
    <div
      class="item-item__status"
      :class="{
        done: props.item.quantity_collected == props.item.quantity_total,
        'not-started': props.item.quantity_collected === 0,
      }"
    />
    <div>
      <div>
        <b>{{ props.item.order_item_number }}</b>
      </div>
      <div>
        {{ props.item.title }}
        <small v-if="props.item.is_added" class="fw-bold c-primary pl-12"
          >({{ $t('suggested-product') }})</small
        >
      </div>
      <!--      <div>-->
      <!--        <small class="text-primary">{{ `${$t('stock')}: ${props.item.quantity_stock}` }}</small>-->
      <!--      </div>-->
      <div>
        <small
          >{{ $t('code') }}:&nbsp;{{ props.item.erp_code }} | {{ $t('barcode') }}:&nbsp;{{
            props.item.barcode.main
          }}</small
        >
      </div>
    </div>
    <div>
      <h5 class="text-nowrap">
        {{ `${props.item.quantity_collected} / ${props.item.quantity_total}` }}
      </h5>
    </div>
  </div>
</template>
